import React from "react";
import { useTranslation } from 'react-i18next';
import {useSelector} from "react-redux";
import {getAppData} from "../../store/slices/appSlice";
import CONST from "../../config/CONST";
import {getSelectedCustomer} from "../../store/slices/userConfigurationsSlice";
import {getFinancialConfiguration} from "../../store/slices/financialConfigurationsSlice";
import ResultTableItem from "../ResultTableItem/ResultTableItem";
import {formatMileage, formatPrice} from "../../helpers/numberFormat";

const Result = () => {

    const { t } = useTranslation();

    const appData = useSelector(getAppData);
    const selectedCustomer = useSelector(getSelectedCustomer) || appData.touchpointConfig.defaults.customer;
    const financialProductConfiguration = useSelector(getFinancialConfiguration);

    if(!financialProductConfiguration) {
        return null;
    }


    return (
        <>
            <div className={`${CONST.CSS_NAMESPACE}Result`}>
                <div className={`${CONST.CSS_NAMESPACE}Result-wrapper`}>
                    <div className={`${CONST.CSS_NAMESPACE}Result-inner`}>
                        {financialProductConfiguration &&
                            <>
                                <div className={`${CONST.CSS_NAMESPACE}container-fluid ${CONST.CSS_NAMESPACE}ResultTable`}>
                                    <ResultTableItem
                                        label={t(`TotalInstallment_${financialProductConfiguration.productTypeCode}`)}
                                        value={formatPrice(appData, financialProductConfiguration.totalInstallment, 2, false)}
                                        className={`${CONST.CSS_NAMESPACE}highlighted`}
                                        vatDisclaimer={t(`VATDisclaimer_${selectedCustomer}`)}
                                    />
                                </div>
                                <div className={`${CONST.CSS_NAMESPACE}container-fluid ${CONST.CSS_NAMESPACE}ResultTable`}>
                                    <ResultTableItem
                                        label={t(`Duration_${financialProductConfiguration.productTypeCode}`)}
                                        value={`${financialProductConfiguration.duration} ${t(`Months`)}`}
                                    />
                                </div>
                                <div className={`${CONST.CSS_NAMESPACE}container-fluid ${CONST.CSS_NAMESPACE}ResultTable`}>
                                    <ResultTableItem
                                        label={t(`Mileage_${financialProductConfiguration.productTypeCode}`)}
                                        value={`${formatMileage(appData, financialProductConfiguration.mileage, false, false)} ${t(`Mileage`)}`}
                                    />
                                </div>
                            </>

                        }
                    </div>
                </div>
            </div>
        </>
    )

}

export default Result;
